export const ORDER_TYPE = {
  Delivery: {
    id: 1,
    slug: "delivery",
    name: "Delivery",
    redeableTiming: "delivery",
    icon: 'k-icon-cab'
  },
  Collection: {
    id: 2,
    slug: "pickup",
    name: "Collection",
    redeableTiming: "pickup",
    icon:"k-icon-pick-up"
  },
  Table: {
    id: 3,
    slug: "sitin",
    name: "Sit in",
    redeableTiming: "tableordering",
    icon:"k-icon-table-ordering"
  },
};

export const ORDER_STATUS = {
  PENDING: 1,
  RECEIVED: 2,
  ACCEPTED: 3,
  DELIVERY: 4,
  COMPLETED: 5,
  REJECTED: 6,
  REFUNDED: 7
}

export const OPTION_TYPE = {
  radio: "RADIO",
  checkbox: "CHECKBOX",
  select: "SELECT",
};

export const STEP_STATUS = {
  PREPARED: 0,
  SAVED: 1,
  COMPLETED: 2,
};

export const STEPS = {
  STEP01: "Step01",
  STEP02: "Step02",
  STEP03: "Step03",
};

export const DIETARY_TYPE = {
  VEGAN: 3,
  VEGETARIAN: 4,
  DAIRYFREE: 5,
  GLUTENFREE: 6,
  HALAL: 7,
  KOSHER: 8,
  NUTS: 9,
};

export const PiCKUP_TIME = {
  ASAP: 1,
  LATER: 2,
}

export const PAYMENT_TYPE = {
  Cash: 1,
  Card: 2,
  ApplePay: 3,
  GooglePay: 4,
}

export const LOCALES = [
  {
      'code'  : 'en',
      'flag'  : '/img/en.png',
      'name'  : 'text.english'
    },
    {
      'code': 'es',
      'flag'  : '/img/es.png',
      'name'  : 'text.spanish'
    }
]

export const ACTIONS = {
  CHECKOUT: "checkout",
  PAY: "pay",
  CONFIRM: "confirm",
}